/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import QuestionMark from "../../../QuestionMark";
import './index.css'

export default class SubGroupTitle extends React.Component {
  constructor(props) {
    super(props);

    this.state = props.params;
  }

  render() {
    const {
      content
    } = this.props;

    return (
      <div className="sub-group-title-wrap clearfix">
          <div data-key={ content.dataKey } className="sub-group-title">
            { content.title }
            { content.questionMark &&
            <QuestionMark questionTitle={ content.title }>
                <hints dataKey={ content.questionMark.dataKey }>{ content.questionMark.hints }</hints>
            </QuestionMark>
            }
          </div>
      </div>
    )
  }
};


SubGroupTitle.propTypes = {
  content: PropTypes.object.isRequired
};
SubGroupTitle.defaultProps = {
  content:{}
};


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/SubGroupTitle/index.js